import React from 'react';
import { Box, Typography } from '@mui/material';
import SharedPatients from '../components/SharedPatients';
import { useAuth } from '../contexts/AuthContext';

/**
 * Patients the offices beneath this level have chosen to share upward — read-only, with
 * their whole visit history. Region, organisation and enterprise admins. An office that
 * hasn't turned on "Share with the levels above" simply doesn't appear here.
 */
export default function NodePatients() {
  const { user } = useAuth();
  const where = user?.node_name || user?.org_name || 'this account';
  return (
    <Box>
      <Typography variant="h4" fontWeight={700}>Patients</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Patients the offices in {where} share with you, and their visit history.
      </Typography>
      <SharedPatients
        emptyHint={`No office in ${where} is sharing its patients upward yet. Each office’s administrator turns this on in Settings → Patient sharing → “Share with the levels above”.`} />
    </Box>
  );
}
